
import { format } from 'date-fns'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FDateRangeField'
})
class FDateRangeField extends Vue {
  @Prop() readonly range!: string[]

  private get formattedDateRange(): string {
    if (this.range.length < 2) return ''
    return `${format(new Date(this.range[0]), 'dd.MM.yyyy')} - ${format(
      new Date(this.range[1]),
      'dd.MM.yyyy'
    )}`
  }
}

export default FDateRangeField
